<template>
  <div class="mt-3 mt-md-4">
    <h5 class="text-dark font-weight-bold mb-3">{{ titulo }}</h5>
    <slot></slot>
  </div>
</template>

<script>
/** Subtítulo dentro de una sección (p. ej. "4.1 Instalación"), literal del Excel. */
export default {
  name: "QSubSeccion",
  props: { titulo: { type: String, required: true } },
};
</script>
